<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '送货单编辑' : '送货单新增'"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <e-form
          ref="refForm"
          :config="formConfig"
          :column="formColumn"
          :rules="formRules"
          :data.sync="selfDetail.form_data"
        />
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :edit-config="tableConfig.editConfig"
          :row-config="tableConfig.rowConfig"
          :mouse-config="tableConfig.mouseConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfDetail.goods_list"
          :show-footer="!!selfDetail.goods_list.length"
          :footer-method="footerMethod"
        >
          <!-- slot_default -->
          <template #default_operate="{ rowIndex }">
            <el-link
              class="f-s-16 iconfont icon-delete"
              title="删行"
              @click="itemDelete(rowIndex)"
            />
          </template>

          <!-- slot_edit -->
          <template #edit_song_huo_count="{ row }">
            <el-input
              v-model="row.song_huo_count"
              type="number"
              size="mini"
              clearable
              @blur="countsBlur(row)"
            />
          </template>
          <template #edit_song_huo_price="{ row }">
            <el-input
              v-model="row.song_huo_price"
              type="number"
              size="mini"
              clearable
              @blur="countsBlur(row)"
            />
          </template>
          <template #edit_goods_remark="{ row }">
            <el-input v-model="row.goods_remark" size="mini" clearable />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <div class="flex flex-y-center flex-x-between">
          <div class="flex flex-y-center">
            <el-button v-if="!billId" size="mini" type="default" @click="popupChooseOrder">
              选择销售订单
            </el-button>
          </div>
          <div class="flex flex-y-center">
            <el-button size="mini" @click="popupCancel">取消</el-button>
            <el-button size="mini" type="primary" @click="popupPush(false)">
              {{ detailId ? '保存' : '创建' }}
            </el-button>
            <el-button size="mini" type="primary" @click="popupPush(true)"> 打印预览 </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 弹窗-选择销售订单 -->
    <PopupChooseOrder
      v-if="isShowPopupChooseOrder"
      :show.sync="isShowPopupChooseOrder"
      @success="updateUpdateChooseOrder"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupChooseOrder: () => import('./popup-choose-order')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    },
    billId: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: false,
      selfDetail: {
        form_data: {
          delivery_id: '', // 送货单id
          delivery_code: '', // 送货单号
          delivery_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 发货日期
          delivery_status: false, // 审核状态
          bill_code: '', // 销售单号
          customer_name: '', // 客户
          customer_id: '', // 客户id
          customer_uuid: '', // 客户uuid
          bu_men_name: '', // 制单部门
          bu_men_id: '', // 制单部门id
          saler_name: '', // 制单人
          saler_id: '', // 制单人id
          saler_company_name: '' // 开单公司
        },
        goods_list: []
      },
      customerList: [],
      customerKeyword: '',
      formConfig: {
        inline: true,
        width: '386px'
      },
      formColumn: [
        {
          type: 'text',
          title: '送货单号',
          field: 'delivery_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'text',
          title: '制单人',
          field: 'saler_name',
          disabled: true
        },
        {
          type: 'select',
          title: '客户',
          field: 'customer_uuid',
          options: [],
          remote: true,
          remoteMethod: (val) => {
            this.customerKeyword = val
            this.getCustomerList(true)
          }
        },
        {
          type: 'select',
          title: '开单公司',
          field: 'saler_company_name',
          options: this.$constant.companyList
        },
        {
          type: 'date',
          title: '发货日期',
          field: 'delivery_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '备注',
          field: 'remark',
          width: '772px'
        },
        {
          type: 'switch',
          title: '审核状态',
          field: 'delivery_status',
          hide: !this.isAdmin
        }
      ],
      formRules: {
        customer_uuid: [{ required: true, message: '请选择客户' }],
        saler_company_name: [{ required: true, message: '请选择开单公司' }],
        delivery_date: [{ required: true, message: '请选择发货日期' }]
      },
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '品名',
          field: 'goods_name'
        },
        {
          title: '规格',
          field: 'goods_spec'
        },
        {
          title: '单位',
          field: 'goods_unit'
        },
        {
          title: '送货数量',
          field: 'song_huo_count',
          slots: { edit: 'edit_song_huo_count' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'song_huo_price',
          slots: { edit: 'edit_song_huo_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '送货金额(元)',
          field: 'song_huo_amount'
        },
        {
          title: '备注',
          field: 'goods_remark',
          slots: { edit: 'edit_goods_remark' },
          editRender: { autofocus: '.el-input__inner' }
        },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      isShowPopupChooseOrder: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.selfDetail.form_data.bu_men_name = this.selfAccountData.bu_men_name.join(',')
      this.selfDetail.form_data.bu_men_id = this.selfAccountData.bu_men_id.join(',')
      this.selfDetail.form_data.saler_name = this.selfAccountData.nick_name
      this.selfDetail.form_data.saler_id = this.selfAccountData.id
      if (this.billId) this.getBillDetail()
    }
    this.getCustomerList()
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo4/detail',
        params: {
          delivery_id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.selfDetail = this.$util.deepCopy(res.data.data)
        }
      })
    },
    // 获取销售订单详情
    getBillDetail() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/detail',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          result.bill_code = result.formData.bill_code
          result.company_name = result.formData.company_name
          result.company_uuid = result.formData.company_uuid
          result.saler_company_name = result.formData.saler_company_name
          this.updateUpdateChooseOrder(result)
        }
      })
    },
    // 获取客户列表
    getCustomerList() {
      this.$api({
        method: 'post',
        url: '/admin/customers/search',
        data: {
          keyword: this.customerKeyword,
          pageSize: 200
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.customer_name,
              val: item.company_uuid,
              id: item.id
            }
          })
          this.customerList = result
          this.formColumn.forEach((item) => {
            if (item.field === 'customer_uuid')
              item.options = this.$util.deepCopy(this.customerList)
          })

          // 用于客户编辑保存成功
          this.customerList.forEach((item) => {
            if (item.val === this.selfDetail.form_data.customer_uuid) {
              this.selfDetail.form_data.customer_name = item.key
              this.selfDetail.form_data.customer_id = item.id
            }
          })
        }
      })
    },
    // 项-删除
    async itemDelete(index) {
      if (this.selfDetail.goods_list.length > 1) {
        this.selfDetail.goods_list.splice(index, 1)
      } else {
        this.selfDetail.goods_list[index].cai_zhi = ''
      }
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['song_huo_count', 'song_huo_price', 'song_huo_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 送货数量-失焦
    countsBlur(row) {
      row.song_huo_amount = this.$XEUtils.multiply(row.song_huo_price, row.song_huo_count)
    },
    // 弹窗-选择销售订单
    popupChooseOrder() {
      this.isShowPopupChooseOrder = true
    },
    // 弹窗-更新选择销售订单
    updateUpdateChooseOrder(row) {
      this.selfDetail.form_data.bill_code = row.bill_code
      this.selfDetail.form_data.customer_name = row.company_name
      this.selfDetail.form_data.customer_uuid = row.company_uuid
      this.selfDetail.form_data.customer_id = row.company_id
      this.selfDetail.form_data.saler_company_name = row.saler_company_name
      this.selfDetail.goods_list = row.tableSaleData.map((item) => {
        let obj = {
          goods_id: '',
          goods_name: item.name,
          goods_spec: item.spec,
          goods_unit: item.unit,
          goods_count: item.counts,
          goods_price: item.goods_price,
          goods_amount: item.goods_amount,
          goods_remark: '',
          song_huo_count: item.counts,
          song_huo_price: item.goods_price,
          song_huo_amount: item.goods_amount
        }
        return obj
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupPush(isPushAndPrint) {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.customerList.forEach((item) => {
            if (item.val === this.selfDetail.form_data.customer_uuid)
              this.selfDetail.form_data.customer_name = item.key
            this.selfDetail.form_data.customer_id = item.id
          })
          if (!this.selfDetail.form_data.delivery_date) {
            this.$message.error('请选择发货日期')
            return
          }
          this.$api({
            method: 'post',
            url: '/admin/gcvip/songHuo4/saveOrUpdate',
            data: this.selfDetail
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
                if (isPushAndPrint) this.popupPrint(res.data.delivery_id)
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    },
    // 项-打印
    popupPrint(id) {
      window.open(`/new/delivery/print?id=${id}`, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
